import { Navigate } from "react-router-dom";

export default function ThankYou() {
  return <Navigate to="/leaderboard" replace />;
}
